module.exports = __webpack_public_path__ + "media/images/off_canvas-4410731bf44d309e0b247bd509e26dcc.jpg";